module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('ul', {
    directives: [{
      name: "dragula",
      rawName: "v-dragula",
      value: (_vm.tree.nodes),
      expression: "tree.nodes"
    }],
    staticClass: "infobits-tree",
    attrs: {
      "bag": "infobits"
    }
  }, _vm._l((_vm.tree.nodes), function(node) {
    return _c('tree-node', {
      key: node.id,
      attrs: {
        "node": node,
        "parent": _vm.tree
      }
    })
  }), 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-4f258c12!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/infobits-tree.vue
// module id = 143
// module chunks = 0